import adminapi from './axios.v2.withoutTransform'

const login = obj => adminapi('user/login', 'POST', obj, false)

const accessTokenLogin = obj => adminapi('user/accessTokenLogin', 'POST', obj)

const logout = () => adminapi('user/logout', 'POST', {})

const resetPassword = email => adminapi('user/getResetPasswordToken', 'POST', { email }, false)

const confirmationResetPassword = obj => adminapi('user/resetPassword', 'PUT', obj, false)

const changePassword = obj => adminapi('user/changePassword', 'PUT', obj)

const signUp = obj => adminapi('user/regularUser', 'POST', obj, false)

const verificationEmail = (token, en) => adminapi(`user/verifyEmail/${token}`, 'PUT', {}, false)

const googleAuth = obj => adminapi('user/google', 'POST', obj, false)

export default { login, accessTokenLogin, logout, resetPassword, confirmationResetPassword, changePassword, signUp, verificationEmail, googleAuth }
